import type { ITeam } from "@medoma/models/patients";
import styles from "./TeamBadge.module.scss";
import { getTeamVisual } from "./getTeamVisual";

interface ITeamBadge {
  team: ITeam;
  size?: "small" | "medium";
  showDisplayName?: boolean;
  width?: "default" | "fit-content";
}

const TeamBadge = ({
  team,
  size = "medium",
  showDisplayName = true,
  width = "default",
}: ITeamBadge) => {
  const { icon, color } = getTeamVisual(team);

  return (
    <div
      className={`${styles.teamBadge} ${styles[`color-${color}`]} ${styles[`size-${size}`]} ${styles[`width-${width}`]}`}
    >
      {icon}
      {showDisplayName && (
        <span className={styles.teamName}>{team.displayName}</span>
      )}
    </div>
  );
};

export default TeamBadge;
